// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"74":"0851f6a4","444":"474072ae","880":"7ee645fc"}[chunkId] + ".css";
};